import React, { useEffect, useState } from "react";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import "./DateRangePicker.css"; // custom css file
import CustomModal from "../custom-modal/CustomModal";

const formatDate = (date) => {
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

const DateRangePicker = ({
  showDateRangePicker,
  setShowDateRangePicker,
  dateRange,
  setDateRange,
}) => {
  const [from, setFrom] = useState(dateRange.startDate);
  const [to, setTo] = useState(dateRange.endDate);

  const [state, setState] = useState([
    {
      startDate: new Date(dateRange.startDate),
      endDate: new Date(dateRange.endDate),
      key: "selection",
    },
  ]);

  useEffect(() => {
    if (from && to) {
      const [fromDay, fromMonth, fromYear] = from.split("/");
      const [toDay, toMonth, toYear] = to.split("/");
      setState([
        {
          startDate: new Date(fromYear, fromMonth - 1, fromDay),
          endDate: new Date(toYear, toMonth - 1, toDay),
          key: "selection",
        },
      ]);
    }
  }, [from, to]);

  const handleFromChange = (e) => {
    const value = e.target.value;
    setFrom(value);
    if (value.length === 10) {
      const [day, month, year] = value.split("/");
      const newStartDate = new Date(year, month - 1, day);
      setState((prevState) => [
        {
          ...prevState[0],
          startDate: newStartDate,
        },
      ]);
    }
  };

  const handleToChange = (e) => {
    const value = e.target.value;
    setTo(value);
    if (value.length === 10) {
      const [day, month, year] = value.split("/");
      const newEndDate = new Date(year, month - 1, day);
      setState((prevState) => [
        {
          ...prevState[0],
          endDate: newEndDate,
        },
      ]);
    }
  };

  const handleCalendarChange = (item) => {
    setState([item.selection]);
    setFrom(formatDate(item.selection.startDate));
    setTo(formatDate(item.selection.endDate));
  };

  return (
    <CustomModal
      isOpen={showDateRangePicker}
      setIsOpen={setShowDateRangePicker}
      title={"Select Custom Date Range"}
      body={
        <DateRange
          editableDateInputs={true}
          onChange={handleCalendarChange}
          moveRangeOnFirstSelection={false}
          ranges={state}
          rangeColors={["#7f56d9"]}
        />
      }
      footer={
        <div className="d-flex justify-content-between gap-2">
          <div className="d-flex gap-2">
            <div className="d-flex flex-column">
              <span className="manual-range-input-label">From</span>
              <input
                type="text"
                className="date-range-input"
                placeholder="dd/mm/yyyy"
                value={from}
                onChange={handleFromChange}
              />
            </div>
            <div className="d-flex flex-column">
              <span className="manual-range-input-label">To</span>
              <input
                type="text"
                className="date-range-input"
                placeholder="dd/mm/yyyy"
                value={to}
                onChange={handleToChange}
              />
            </div>
          </div>
          <div className="d-flex align-items-end">
            <button
              className="apply-filter-btn"
              onClick={() => {
                setDateRange({
                  startDate: formatDate(state[0].startDate),
                  endDate: formatDate(state[0].endDate),
                });
                setShowDateRangePicker(false);
              }}
            >
              Apply Date Range
            </button>
          </div>
        </div>
      }
    />
  );
};

export default DateRangePicker;
